import { getFirstPartyVisitorId } from './first-party-visitor-id';

/**
 * The visitor id used for attribution — signup correlation and Segment's
 * anonymousId. Sourced from our own first-party cookie (`first-party-visitor-id.ts`)
 * rather than from Segment, so the id stays the same for a visitor whether or
 * not Segment ever loads for them (e.g. once Segment sits behind consent).
 */
export function getAnonymousCorrelationId() {
  return getFirstPartyVisitorId();
}
